module.exports = __webpack_public_path__ + "static/media/Customer-service-excellence.2a06bcd5.jpg";